// Metric Cards
export const MOCK_METRIC_CARDS_DATA_1 = {
  totalSpend: {
    content: 6119.77,
    mtdCurrContent: 6119.77,
    mtdPrevContent: 5719.77,
    ytdCurrContent: 6119.77,
    ytdPrevContent: 5719.77,
  },
  spendShare: {
    content: 3.8,
    mtdCurrContent: 3.8,
    mtdPrevContent: 3.6,
    ytdCurrContent: 3.8,
    ytdPrevContent: 3.6,
  },
  averagePriceUnit: {
    content: 33.32,
    mtdCurrContent: 33.32,
    mtdPrevContent: 29.32,
    ytdCurrContent: 33.32,
    ytdPrevContent: 29.32,
  },
  theoreticalActual: {
    content: 6119.77,
    mtdCurrContent: 6119.77,
    mtdPrevContent: 5719.77,
    ytdCurrContent: 6119.77,
    ytdPrevContent: 5719.77,
  },
  numberOfActiveSKUs: {
    content: 7,
    mtdCurrContent: 7,
    mtdPrevContent: 3,
    ytdCurrContent: 7,
    ytdPrevContent: 3,
  },
}

// Overview Tab
export const MOCK_ASSIGNED_STATUS_DATA_1 = [
  // TODO: more realistic mock data
  {
    preferredDistributor: 'Sysco',
    preferredManufacturer: 'Califia',
    primaryPreferredSku: 'Califia Barista 1L',
    keyAttributeChoice: 'Barista-format, plant-based',
  },
  {
    preferredDistributor: 'Odeko',
    preferredManufacturer: 'Califia',
    primaryPreferredSku: 'Califia Barista 1L',
    keyAttributeChoice: 'Barista-format, plant-based',
  },
]

export const MOCK_SNAPSHOT_DATA_1 = [
  // TODO: more realistic mock data
  {
    totalSpend: 450000,
    categoryShareOfTotalSpend: 13.5,
    avgUnitPrice: 1.35,
    plannedVsActualCost: 12.5,
    compliantStores: 15 / 20,
  },
  {
    totalSpend: 350000,
    categoryShareOfTotalSpend: 10.5,
    avgUnitPrice: 1.35,
    plannedVsActualCost: 12.5,
    compliantStores: 15 / 20,
  },
  {
    totalSpend: 250000,
    categoryShareOfTotalSpend: 7.5,
    avgUnitPrice: 1.35,
    plannedVsActualCost: 12.5,
    compliantStores: 15 / 20,
  },
  {
    totalSpend: 150000,
    categoryShareOfTotalSpend: 13.5,
    avgUnitPrice: 1.35,
    plannedVsActualCost: 12.5,
    compliantStores: 15 / 20,
  },
  {
    totalSpend: 50000,
    categoryShareOfTotalSpend: 1.5,
    avgUnitPrice: 1.35,
    plannedVsActualCost: 12.5,
    compliantStores: 15 / 20,
  },
  {
    totalSpend: 450000,
    categoryShareOfTotalSpend: 13.5,
    avgUnitPrice: 1.35,
    plannedVsActualCost: 12.5,
    compliantStores: 15 / 20,
  },
]

// Spend Tab
export const MOCK_SUPPLIER_BREAKDOWN_DATA_1 = {
  rawData: [
    [1200, 1436, 1534, 1670, 1750, 2400, 1820, 2100, 1900, 2000, 2200, 2300],
    [725, 789, 823, 856, 889, 923, 1023, 956, 989, 1056, 1089, 1123],
    [33.6, 37.6, 38.6, 39.6, 40.6, 41.6, 32.6, 43.6, 24.6, 35.6, 40.6, 47.6],
  ],
  seriesNames: ['Sysco', 'Odeko', 'Leakage'],
  xAxisNames: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
}

// Sku Breakdown Tab
export const MOCK_OPTIMIZATIONS_DATA_1 = [
  { name: 'Oat Milk Blend Barista', value: 32.78 },
  { name: 'Oat Milk Plant Based', value: 28.32 },
]

export const MOCK_PRICE_COMPLIANCE_DATA_1 = [
  { name: 'Oat Milk Blend Barista', value: 100 },
  { name: 'Oat Milk Plant Based', value: 100 },
]

export const MOCK_ATTRIBUTE_SPLIT_DATA_1 = {
  record: { 'Barista-format': 40, 'Plant-based': 60 },
  labels: ['Barista-format', 'Plant-based'],
}

export const MOCK_DETAILED_INFORMATION_DATA_1 = [
  {
    skuName: 'Oat Milk Blend Barista',
    status: 'Approved',
    minCode: 'MIN-965',
    manufacturer: 'Performance Foodservice',
    contactPrice: 34.32,
    lastPricePaid: 34.32,
    priceCompPercentage: 100,
    rccSpendPercentage: 1.3,
    lastOrderDate: '06-23-2024',
  },
  {
    skuName: 'Oat Milk Plant Based',
    status: 'Preferred',
    minCode: 'MIN-962',
    manufacturer: 'Merchants Foodservice',
    contactPrice: 32.32,
    lastPricePaid: 32.32,
    priceCompPercentage: 100,
    rccSpendPercentage: 1.1,
    lastOrderDate: '06-22-2024',
  },
]

// Price History Tab
export const MOCK_PRICE_HISTORY_DATA_1 = {
  'Per Unit': [
    { month: 'Jan', price: 33.5 },
    { month: 'Feb', price: 34.32 },
    { month: 'Mar', price: 32.32 },
    { month: 'Apr', price: 34.1 },
    { month: 'May', price: 33.05 },
    { month: 'Jun', price: 32.0 },
    { month: 'Jul', price: 32.32 },
    { month: 'Aug', price: 35.2 },
    { month: 'Sep', price: 33.2 },
    { month: 'Oct', price: 32.32 },
    { month: 'Nov', price: 32.5 },
    { month: 'Dec', price: 33.2 },
  ],
}

export const MOCK_ALL_SKUS_DATA_1 = [
  {
    skuName: 'Oat Milk Blend Barista',
    jan: 35.5,
    feb: 36.32,
    mar: 34.5,
    apr: 34.1,
    may: 35.05,
    jun: 34.0,
    jul: 34.32,
    aug: 36.2,
    sep: 34.2,
    oct: 33.32,
    nov: 33.5,
    dec: 35.2,
  },
  {
    skuName: 'Oat Milk Plant Based',
    jan: 33.5,
    feb: 34.32,
    mar: 17.5,
    apr: 34.1,
    may: 33.05,
    jun: 32.0,
    jul: 32.32,
    aug: 35.2,
    sep: 33.2,
    oct: 32.32,
    nov: 32.5,
    dec: 33.2,
  },
]

// Compliance Tab
export const MOCK_COMPLIANCE_PIE_CHART_DATA_1 = {
  record: { Preferred: 40, Approved: 60, 'Non-contracted': 0 },
  labels: ['Preferred', 'Approved', 'Non-contracted'],
}

export const MOCK_COMPLIANCE_DATA_1 = {
  'Compliance %': [
    { month: 'Jan', price: 60.5 },
    { month: 'Feb', price: 59.5 },
    { month: 'Mar', price: 61.5 },
    { month: 'Apr', price: 60.5 },
    { month: 'May', price: 60.5 },
    { month: 'Jun', price: 62.5 },
    { month: 'Jul', price: 63.5 },
    { month: 'Aug', price: 59.5 },
    { month: 'Sep', price: 60.5 },
    { month: 'Oct', price: 62.5 },
    { month: 'Nov', price: 61.5 },
    { month: 'Dec', price: 60.7 },
  ],
}

export const MOCK_TOP_5_LEAKAGE_SKUS_DATA_1 = [
  // TODO: more realistic mock data
  {
    storeName: 'Vista',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
  },
  {
    storeName: 'Harrington',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
    lastOrderDate: '06-23-2024',
  },
  {
    storeName: 'Silverbrook',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
  },
  {
    storeName: 'Ashburn',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
    lastOrderDate: '06-23-2024',
  },
  {
    storeName: 'Kingbury',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
    lastOrderDate: '06-23-2024',
  },
]

export const MOCK_LAST_5_LEAKAGE_SKUS_DATA_1 = [
  // TODO: more realistic mock data
  {
    storeName: 'Red Fork',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
  },
  {
    storeName: 'Brookhaven West',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
    lastOrderDate: '06-23-2024',
  },
  {
    storeName: 'Rolling Meadows',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
  },
  {
    storeName: 'Dalton',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
    lastOrderDate: '06-23-2024',
  },
  {
    storeName: 'Pine Bluff',
    leakageLoss: 100,
    supplierCompliancePercentage: 100,
    skuCompliancePercentage: 100,
    supplierMix: 'Torani',
    ordersOnPcardPercentage: 100,
    lastComplianceBreachDate: '06-23-2024',
    lastOrderDate: '06-23-2024',
  },
]

// Theoretical Vs Actual Tab
// Mock data for waterfall chart showing cost breakdown
export const MOCK_WATERFALL_DATA_1 = {
  values: [6120, -122.4, -91.8, -73.44, -5832.36],
  labels: [
    'Actual Cost',
    'Price Variance',
    'Waste Variance',
    'Compliance Variance',
    'Theoretical Cost',
  ],
}

export const MOCK_THEORETICAL_VS_ACTUAL_DATA_1 = {
  Actual: [
    { month: 'Jan', price: 33 },
    { month: 'Feb', price: 30 },
    { month: 'Mar', price: 36.96 },
    { month: 'Apr', price: 35.52 },
    { month: 'May', price: 35.04 },
    { month: 'Jun', price: 35.04 },
    { month: 'Jul', price: 34.08 },
    { month: 'Aug', price: 36.96 },
    { month: 'Sep', price: 31.7 },
    { month: 'Oct', price: 32.04 },
    { month: 'Nov', price: 32.38 },
    { month: 'Dec', price: 32.72 },
  ],
  Theoretical: [
    { month: 'Jan', price: 28.11 },
    { month: 'Feb', price: 29.1 },
    { month: 'Mar', price: 27.16 },
    { month: 'Apr', price: 26.16 },
    { month: 'May', price: 27.04 },
    { month: 'Jun', price: 32.04 },
    { month: 'Jul', price: 31.08 },
    { month: 'Aug', price: 30.96 },
    { month: 'Sep', price: 30.72 },
    { month: 'Oct', price: 32.04 },
    { month: 'Nov', price: 32.25 },
    { month: 'Dec', price: 32.22 },
  ],
}

export const MOCK_VARIANCE_ATTRIBUTION_DATA_1 = {
  record: { Price: 122.4, Waste: 91.8, Compliance: 73.44 },
  labels: ['Price', 'Waste', 'Compliance'],
}

export const MOCK_STORE_LEADERBOARD_DATA_1 = [
  // TODO: more realistic mock data
  {
    storeName: 'Vista',
    deviationPercentage: 100,
    deviation: 100,
    totalUnitsConsumed: 100,
  },
  {
    storeName: 'Harrington',
    deviationPercentage: 100,
    deviation: 100,
    totalUnitsConsumed: 100,
  },
  {
    storeName: 'Silverbrook',
    deviationPercentage: 100,
    deviation: 100,
    totalUnitsConsumed: 100,
  },
  {
    storeName: 'Ashburn',
    deviationPercentage: 100,
    deviation: 100,
    totalUnitsConsumed: 100,
  },
  {
    storeName: 'Kingbury',
    deviationPercentage: 100,
    deviation: 100,
    totalUnitsConsumed: 100,
  },
]

export const MOCK_SALES_ITEM_LEADERBOARD_DATA_1 = [
  {
    salesItemName: 'Caramel Latte',
    varianceImpact: 100,
    unitsSold: 28,
  },
  {
    salesItemName: 'Americano',
    varianceImpact: 100,
    unitsSold: 26,
  },
  {
    salesItemName: 'Cold Brew',
    varianceImpact: 100,
    unitsSold: 22,
  },
  {
    salesItemName: 'Snow Peak',
    varianceImpact: 100,
    unitsSold: 20,
  },
  {
    salesItemName: 'Cream Dream',
    varianceImpact: 100,
    unitsSold: 14,
  },
]

// 3-Level Spend Lens Data Structure
// Level 1: Categories (displayed in cards)
export const MOCK_SPEND_CATEGORIES_DATA = [
  {
    item: 'Milk & Dairy',
    current: {
      totalSpend: 31130,
      spendShare: 19.3,
      averagePriceUnit: 20.28,
      theoreticalActual: 983.03,
      numberOfActiveSKUs: 12,
    },
    prev: {
      totalSpend: 30320,
      spendShare: 19.1,
      averagePriceUnit: 18.84,
      theoreticalActual: 830.23,
      numberOfActiveSKUs: 11,
    },
  },
]

// Level 2: Items within categories (displayed in table)
export const MOCK_DAIRY_ITEMS_DATA = [
  {
    item: '2% Milk',
    current: {
      totalSpend: 475.88,
      spendShare: 1.5,
      averagePriceUnit: 4.1,
      theoreticalActual: 475.88,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 450.88,
      spendShare: 1.4,
      averagePriceUnit: 4.1,
      theoreticalActual: 450.88,
      numberOfActiveSKUs: 6,
    },
  },
  {
    item: 'Alternative Milk',
    current: {
      totalSpend: 6781.7,
      spendShare: 21.8,
      averagePriceUnit: 32.79,
      theoreticalActual: 6781.7,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 6521.7,
      spendShare: 20.6,
      averagePriceUnit: 32.79,
      theoreticalActual: 6421.7,
      numberOfActiveSKUs: 5,
    },
  },
  {
    item: 'Half & Half',
    current: {
      totalSpend: 1268.64,
      spendShare: 4.1,
      averagePriceUnit: 2.99,
      theoreticalActual: 1268.64,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 1326.64,
      spendShare: 4.2,
      averagePriceUnit: 2.99,
      theoreticalActual: 1326.64,
      numberOfActiveSKUs: 5,
    },
  },
  {
    item: 'HWC',
    current: {
      totalSpend: 1286.75,
      spendShare: 4.1,
      averagePriceUnit: 6.7,
      theoreticalActual: 1286.75,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 1276.75,
      spendShare: 4.0,
      averagePriceUnit: 6.7,
      theoreticalActual: 1276.75,
      numberOfActiveSKUs: 5,
    },
  },
  {
    item: 'Ice Cream',
    current: {
      totalSpend: 1382.87,
      spendShare: 4.4,
      averagePriceUnit: 29.01,
      theoreticalActual: 1382.87,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 1572.87,
      spendShare: 5.0,
      averagePriceUnit: 31.01,
      theoreticalActual: 1572.87,
      numberOfActiveSKUs: 5,
    },
  },
  {
    item: 'Skim Milk',
    current: {
      totalSpend: 707.03,
      spendShare: 2.3,
      averagePriceUnit: 3.99,
      theoreticalActual: 707.03,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 737.03,
      spendShare: 2.3,
      averagePriceUnit: 3.9,
      theoreticalActual: 737.03,
      numberOfActiveSKUs: 5,
    },
  },
  {
    item: 'Whip Cream',
    current: {
      totalSpend: 5902.86,
      spendShare: 19.0,
      averagePriceUnit: 41.35,
      theoreticalActual: 5902.86,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 6102.86,
      spendShare: 19.2,
      averagePriceUnit: 42.85,
      theoreticalActual: 6102.86,
      numberOfActiveSKUs: 5,
    },
  },
  {
    item: 'Whole Milk',
    current: {
      totalSpend: 13323.52,
      spendShare: 42.8,
      averagePriceUnit: 44.16,
      theoreticalActual: 13323.52,
      numberOfActiveSKUs: 6,
    },
    prev: {
      totalSpend: 13723.52,
      spendShare: 43.3,
      averagePriceUnit: 45.66,
      theoreticalActual: 13723.52,
      numberOfActiveSKUs: 5,
    },
  },
]

// Level 3: SKU Details (displayed when item row is expanded)
export const MOCK_MILK_SKUS_DATA = [
  {
    item: 'Whole Milk',
    current: {
      totalSpend: 50000,
      averagePriceUnit: 1.52,
      spendShare: 41.7,
      theoreticalActual: 2.2,
      numberOfActiveSKUs: 3,
    },
    prev: {
      totalSpend: 48000,
      averagePriceUnit: 1.48,
      spendShare: 41.7,
      theoreticalActual: 2.0,
      numberOfActiveSKUs: 3,
    },
  },
  {
    item: 'Half & Half',
    current: {
      totalSpend: 45000,
      averagePriceUnit: 1.45,
      spendShare: 37.5,
      theoreticalActual: 1.8,
      numberOfActiveSKUs: 2,
    },
    prev: {
      totalSpend: 42000,
      averagePriceUnit: 1.42,
      spendShare: 36.5,
      theoreticalActual: 1.6,
      numberOfActiveSKUs: 2,
    },
  },
  {
    item: 'Skim Milk',
    current: {
      totalSpend: 25000,
      averagePriceUnit: 1.38,
      spendShare: 20.8,
      theoreticalActual: 1.2,
      numberOfActiveSKUs: 1,
    },
    prev: {
      totalSpend: 25000,
      averagePriceUnit: 1.35,
      spendShare: 21.7,
      theoreticalActual: 1.2,
      numberOfActiveSKUs: 1,
    },
  },
]

export const MOCK_ALTERNATIVE_MILK_SKUS_DATA = [
  {
    item: 'Almond Milk',
    current: {
      totalSpend: 116.93,
      averagePriceUnit: 17.42,
      spendShare: 1.7,
      theoreticalActual: 116.93,
      numberOfActiveSKUs: 3,
    },
    prev: {
      totalSpend: 105.23,
      averagePriceUnit: 17.42,
      spendShare: 1.6,
      theoreticalActual: 105.23,
      numberOfActiveSKUs: 2,
    },
  },
  {
    item: 'Oat Milk',
    current: {
      totalSpend: 6119.77,
      averagePriceUnit: 33.32,
      spendShare: 90.2,
      theoreticalActual: 6119.77,
      numberOfActiveSKUs: 7,
    },
    prev: {
      totalSpend: 5719.77,
      averagePriceUnit: 29.32,
      spendShare: 89.4,
      theoreticalActual: 5719.77,
      numberOfActiveSKUs: 3,
    },
  },
  {
    item: 'Coconut Milk',
    current: {
      totalSpend: 545,
      averagePriceUnit: 32.7,
      spendShare: 8.0,
      theoreticalActual: 545,
      numberOfActiveSKUs: 5,
    },
    prev: {
      totalSpend: 575,
      averagePriceUnit: 33.7,
      spendShare: 9.0,
      theoreticalActual: 575,
      numberOfActiveSKUs: 3,
    },
  },
]

// Helper function to get Level 2 data based on category name
export const getMockLevel2Data = (categoryName: string) => {
  switch (categoryName) {
    case 'Milk & Dairy':
      return MOCK_DAIRY_ITEMS_DATA
    default:
      return []
  }
}

// Helper function to get Level 3 data based on item name
export const getMockLevel3Data = (itemName: string) => {
  switch (itemName) {
    // case '%2 Milk':
    //   return MOCK_MILK_SKUS_DATA
    case 'Alternative Milk':
      return MOCK_ALTERNATIVE_MILK_SKUS_DATA
    default:
      return []
  }
}

// TODO: ------------------------------------
// ================================
// DATASET 2 - Contrasting Data Set
// ================================

// Metric Cards - DATA_2 (Matched with Almond Croissant)
export const MOCK_METRIC_CARDS_DATA_2 = {
  totalSpend: {
    content: 70000,
    mtdCurrContent: 68000,
    mtdPrevContent: 72000,
    ytdCurrContent: 820000,
    ytdPrevContent: 780000,
  },
  spendShare: {
    content: 63.8,
    mtdCurrContent: 62.5,
    mtdPrevContent: 64.8,
    ytdCurrContent: 61.9,
    ytdPrevContent: 59.2,
  },
  averagePriceUnit: {
    content: 2.45,
    mtdCurrContent: 2.42,
    mtdPrevContent: 2.48,
    ytdCurrContent: 2.44,
    ytdPrevContent: 2.38,
  },
  theoreticalActual: {
    content: 10.8,
    mtdCurrContent: 11.2,
    mtdPrevContent: 9.9,
    ytdCurrContent: 10.5,
    ytdPrevContent: 9.8,
  },
  numberOfActiveSKUs: {
    content: 11,
    mtdCurrContent: 11,
    mtdPrevContent: 10,
    ytdCurrContent: 12,
    ytdPrevContent: 9,
  },
}

// Level 1: Categories - DATA_2
export const MOCK_SPEND_CATEGORIES_DATA_2 = [
  {
    item: 'Dairy',
    current: {
      totalSpend: 85000,
      spendShare: 5.3,
      averagePriceUnit: 0.95,
      theoreticalActual: 3.2,
      numberOfActiveSKUs: 8,
    },
    prev: {
      totalSpend: 92000,
      spendShare: 5.8,
      averagePriceUnit: 0.98,
      theoreticalActual: 3.8,
      numberOfActiveSKUs: 7,
    },
  },
  {
    item: 'Food',
    current: {
      totalSpend: 950000,
      spendShare: 59.4,
      averagePriceUnit: 3.85,
      theoreticalActual: 28.5,
      numberOfActiveSKUs: 22,
    },
    prev: {
      totalSpend: 880000,
      spendShare: 55.3,
      averagePriceUnit: 3.68,
      theoreticalActual: 25.8,
      numberOfActiveSKUs: 20,
    },
  },
  {
    item: 'Sauces & Bases',
    current: {
      totalSpend: 180000,
      spendShare: 11.3,
      averagePriceUnit: 0.65,
      theoreticalActual: 2.8,
      numberOfActiveSKUs: 15,
    },
    prev: {
      totalSpend: 195000,
      spendShare: 12.3,
      averagePriceUnit: 0.68,
      theoreticalActual: 3.2,
      numberOfActiveSKUs: 14,
    },
  },
  {
    item: 'Coffee & Tea',
    current: {
      totalSpend: 120000,
      spendShare: 7.5,
      averagePriceUnit: 8.8,
      theoreticalActual: 4.2,
      numberOfActiveSKUs: 9,
    },
    prev: {
      totalSpend: 135000,
      spendShare: 8.5,
      averagePriceUnit: 9.2,
      theoreticalActual: 4.8,
      numberOfActiveSKUs: 8,
    },
  },
  {
    item: 'Packaging & Supplies',
    current: {
      totalSpend: 265000,
      spendShare: 16.6,
      averagePriceUnit: 0.22,
      theoreticalActual: 6.8,
      numberOfActiveSKUs: 18,
    },
    prev: {
      totalSpend: 290000,
      spendShare: 18.2,
      averagePriceUnit: 0.25,
      theoreticalActual: 7.5,
      numberOfActiveSKUs: 17,
    },
  },
]

// Level 2: Items within categories - DATA_2
export const MOCK_DAIRY_ITEMS_DATA_2 = [
  {
    item: 'Milk',
    current: {
      totalSpend: 35000,
      spendShare: 41.2,
      averagePriceUnit: 0.88,
      theoreticalActual: 1.5,
      numberOfActiveSKUs: 4,
    },
    prev: {
      totalSpend: 38000,
      spendShare: 41.3,
      averagePriceUnit: 0.92,
      theoreticalActual: 1.8,
      numberOfActiveSKUs: 4,
    },
  },
  {
    item: 'Alternative Milk',
    current: {
      totalSpend: 50000,
      spendShare: 58.8,
      averagePriceUnit: 1.02,
      theoreticalActual: 1.7,
      numberOfActiveSKUs: 4,
    },
    prev: {
      totalSpend: 54000,
      spendShare: 58.7,
      averagePriceUnit: 1.05,
      theoreticalActual: 2.0,
      numberOfActiveSKUs: 3,
    },
  },
]

export const MOCK_FOOD_ITEMS_DATA_2 = [
  {
    item: 'Pastry',
    current: {
      totalSpend: 580000,
      spendShare: 61.1,
      averagePriceUnit: 4.25,
      theoreticalActual: 18.8,
      numberOfActiveSKUs: 14,
    },
    prev: {
      totalSpend: 530000,
      spendShare: 60.2,
      averagePriceUnit: 4.05,
      theoreticalActual: 16.5,
      numberOfActiveSKUs: 13,
    },
  },
  {
    item: 'Cake',
    current: {
      totalSpend: 370000,
      spendShare: 38.9,
      averagePriceUnit: 3.45,
      theoreticalActual: 9.7,
      numberOfActiveSKUs: 8,
    },
    prev: {
      totalSpend: 350000,
      spendShare: 39.8,
      averagePriceUnit: 3.32,
      theoreticalActual: 9.3,
      numberOfActiveSKUs: 7,
    },
  },
]

// Level 3: SKU Details - DATA_2
export const MOCK_PASTRY_SKUS_DATA_2 = [
  {
    item: 'Almond Croissant',
    current: {
      totalSpend: 70000,
      averagePriceUnit: 2.45,
      unitsOrdered: 28571,
      theoreticalActual: 2.2,
      numberOfActiveSKUs: 11,
    },
    prev: {
      totalSpend: 65000,
      averagePriceUnit: 2.38,
      unitsOrdered: 27311,
      theoreticalActual: 2.0,
      numberOfActiveSKUs: 10,
    },
  },
  {
    item: 'Chocolate Croissant',
    current: {
      totalSpend: 245000,
      averagePriceUnit: 4.85,
      unitsOrdered: 50515,
      theoreticalActual: 7.8,
      numberOfActiveSKUs: 2,
    },
    prev: {
      totalSpend: 235000,
      averagePriceUnit: 4.72,
      unitsOrdered: 49788,
      theoreticalActual: 7.2,
      numberOfActiveSKUs: 2,
    },
  },
  {
    item: 'Croissant',
    current: {
      totalSpend: 265000,
      averagePriceUnit: 4.25,
      unitsOrdered: 62353,
      theoreticalActual: 8.8,
      numberOfActiveSKUs: 1,
    },
    prev: {
      totalSpend: 230000,
      averagePriceUnit: 4.05,
      unitsOrdered: 56790,
      theoreticalActual: 7.3,
      numberOfActiveSKUs: 1,
    },
  },
]

// Helper functions for DATA_2
export const getMockLevel2Data_2 = (categoryName: string) => {
  switch (categoryName) {
    case 'Dairy':
      return MOCK_DAIRY_ITEMS_DATA_2
    case 'Food':
      return MOCK_FOOD_ITEMS_DATA_2
    default:
      return []
  }
}

export const getMockLevel3Data_2 = (itemName: string) => {
  switch (itemName) {
    case 'Pastry':
      return MOCK_PASTRY_SKUS_DATA_2
    default:
      return []
  }
}
